// extracted by mini-css-extract-plugin
export default {"header":"zS-z","logo":"AS-z","signin":"BS-z"};